import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from './authentication.service';
import { first } from 'rxjs/operators';
import { ConfigDB } from '../common/data/config/config';
import { TranslateService } from '@ngx-translate/core';
import { CustomizerService } from '../common/services/customizer.service';

type UserFields = 'email' | 'password';
type FormErrors = { [u in UserFields]: string };

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;

    submitted = false;
    returnUrl: string;
    error = '';
    loading: boolean = false;
    takaful: string = "";
    takafulswitch: string = "";
    takafulmode: string = "";

    defaultLang: string = "";
    hideLang: string = "";

    providerCode: string = "";
    userID: string = "";
    userToken: string = "";
    passCode: string = "";
    redirectUrl: string = "";
    loginError: string = "";
    rootDir: string = "";

    constructor(public authService: AuthenticationService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private configDB: ConfigDB,
        private translate: TranslateService,
        private customizer:CustomizerService) {

        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        if (browserWindowEnv.hasOwnProperty('rootDir')) {
            this.rootDir = window['__env']['rootDir'];
        }

        if (browserWindowEnv.hasOwnProperty('providerCode')) {
            this.providerCode = window['__env']['providerCode'];
        }

        if (browserWindowEnv.hasOwnProperty('userID')) {
            this.userID = window['__env']['userID'];
        }

        if (browserWindowEnv.hasOwnProperty('passCode')) {
            this.passCode = window['__env']['passCode'];
        }

        if (browserWindowEnv.hasOwnProperty('redirectUrl')) {
            this.redirectUrl = window['__env']['redirectUrl'];
            if (this.redirectUrl) this.redirectUrl = this.redirectUrl.replace(/&amp;/g, '&');
        }

        if (browserWindowEnv.hasOwnProperty('loginError')) {
            this.loginError = window['__env']['loginError'];
            this.error = this.loginError;
        }

        if (browserWindowEnv.hasOwnProperty('userToken')) {
            this.userToken = window['__env']['userToken'];
        }
        
        if (browserWindowEnv.hasOwnProperty('takaful')) {
            this.takaful = window['__env']['takaful'];        
        }

        if (browserWindowEnv.hasOwnProperty('takafulswitch')) {
            this.takafulswitch = window['__env']['takafulswitch'];
        }

        if (browserWindowEnv.hasOwnProperty('defaultLang')) {
            this.defaultLang = window['__env']['defaultLang'];
            if (this.defaultLang == "1")
                this.translate.use('en');
            else if (this.defaultLang == "2")
                this.translate.use('ar');
            else if (this.defaultLang == "3")
                this.translate.use('fr');
        }

        if (browserWindowEnv.hasOwnProperty('HideLang')) {
            this.hideLang = window['__env']['HideLang'];
        }

        if (this.authService.User) {
            this.router.navigate(['/']);
        }
        else {

            document.body.setAttribute("style", "background-image:url('" + this.rootDir  + configDB.data.background + "');background-size: cover");
        }
    }

    setLanguage(language) {
        this.translate.use(language);
    }

    ngOnInit() {

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        if (this.providerCode) {
            this.loginForm.patchValue({
                username: this.userID,
                password: this.passCode
            })
        }
    }

    get f() { return this.loginForm.controls; }


    // Simple Login
    onSubmit() {
        this.error = null;
        this.submitted = true;

        if (this.loginForm.invalid) {
            return;
        }

        if (this.takaful == "true" && this.takafulmode == "conventional") {
            window['__env']['takaful'] = "false";
            this.configDB.data = this.configDB.conventional;
            this.customizer.removeStyle();
            this.translate.reloadLang(this.translate.currentLang);
        }
        else if (this.takaful != "true" && this.takafulmode == "takaful") {
            window['__env']['takaful'] = "true";
            this.configDB.data = this.configDB.takaful;
            this.customizer.createStyle('color-2');
            this.translate.reloadLang(this.translate.currentLang);
        }

        this.loading = true;
        this.authService.login(this.f.username.value, this.f.password.value, this.passCode)
            .pipe(first())
            .subscribe(
                data => {
                    this.loading = false;
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.loading = false;
                    var exception = error;
                    this.error = "Unable to login.";
                });
    }

}
